'use client';

import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';
import { DURATION_DEFAULT } from './constants';

interface AnimatePresenceWrapperProps {
  show: boolean;
  className?: string;
  children: ReactNode;
}

export function AnimatePresenceWrapper({ show, className, children }: AnimatePresenceWrapperProps) {
  const prefersReducedMotion = useReducedMotion();
  const instant = prefersReducedMotion;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={instant ? false : { opacity: 0, height: 0, y: -8 }}
          animate={{ opacity: 1, height: 'auto', y: 0 }}
          exit={instant ? { opacity: 0 } : { opacity: 0, height: 0, y: -8 }}
          transition={instant ? { duration: 0 } : { duration: DURATION_DEFAULT }}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
